import { getReduxStore } from 'store/storeRegistry';
import checkFeatureFlag from 'utils/featureFlags';
export const CREDIT_REPORT_PROVIDER = 'CREDIT_REPORT';
export const isCreditReportConnection = (connection) => connection.bankInfo?.provider === CREDIT_REPORT_PROVIDER;
export const isCreditReportAccount = (account) => account.provider === CREDIT_REPORT_PROVIDER;
/**
 * Connections the user linked to a bank themselves. Excludes the offline
 * (MANUAL) connection and the credit report connection, neither of which
 * counts towards bank login limits or syncs with a bank.
 */
export const isBankLoginConnection = (connection) => connection.bankInfo.provider !== 'MANUAL' && !isCreditReportConnection(connection);
/**
 * Whether API requests should ask for credit report accounts, behind the
 * `track_your_mortgage` flag. False until the store is registered.
 */
export const shouldIncludeCreditReport = () => {
    try {
        return checkFeatureFlag(getReduxStore().getState().utils.featureFlags, 'track_your_mortgage');
    }
    catch {
        return false;
    }
};
/** `includeCreditReport=true` prefixed with `separator`, or '' when the flag is off. */
export const includeCreditReportParam = (separator) => shouldIncludeCreditReport() ? `${separator}includeCreditReport=true` : '';
